// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadCards-module--container--1x7RY"};